import { Maybe, PaymentMethodState, B2BPaymentMethod, CorePaymentMethod } from "@oysterhr/schema"
import { Alert, Link } from "@oysterhr/ui"
import { useCallback, useState } from "react"
import { useTranslation } from "react-i18next"
import { isFtePaymentMethod } from "../utils"

interface Props {
  paymentMethod?: Maybe<CorePaymentMethod | B2BPaymentMethod>
  onDelete: (paymentMethod: CorePaymentMethod | B2BPaymentMethod) => void
}

const getLocalStorageKey = (type?: string) => `hide-verification-failure-alert-${type ?? ""}`

export const VerificationFailureAlert = ({ paymentMethod, onDelete }: Props) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow", {
    keyPrefix: "alerts.verificationFailure",
  })
  const [bannerShown, setBannerShown] = useState(() => {
    return window.localStorage.getItem(getLocalStorageKey(paymentMethod?.__typename)) !== "true"
  })
  const handleCloseBanner = useCallback(() => {
    window.localStorage.setItem(getLocalStorageKey(paymentMethod?.__typename), "true")
    setBannerShown(false)
  }, [paymentMethod?.__typename])

  if (!bannerShown || paymentMethod?.state !== PaymentMethodState.VerificationFailed) return null

  return (
    <Alert variation="error" onRequestClose={handleCloseBanner}>
      <Alert.Icon />
      <Alert.Content className="flex space-x-1">
        <div>
          {t("content", {
            category: isFtePaymentMethod(paymentMethod) ? t("fte") : t("contractor"),
          })}
        </div>
        <div>
          <Link as="button" onClick={() => onDelete(paymentMethod)}>
            {t("action")}
          </Link>
        </div>
      </Alert.Content>
    </Alert>
  )
}
